import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import axios from 'axios';
import { root_url } from '../setting';
const SNS = () => {
  const [imgUrl, setImgUrl] = useState([]);
  useEffect(() => {
    const getData = async () => {
      try {
        let response = await axios.post(`${root_url}/api/v1/footprint`, {
          runnerSeq: 70,
          runnerName: "고현지",
          cellphone: "01020247274"
        });
        let photos = response.data.photos;
        setImgUrl(photos);
      } catch (error) {
        if (error.response === undefined) {
          alert(
            '시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)'
          );
          console.log('error', error);
          return;
        } else {
          alert(error.response.data.errorMessage);
          return;
        }
      }
    }
    getData();

  }, []);
  return (
    <Container>
      <h1 className="mt-3 mb-5">갤러리</h1>
      <div style={{ textAlign: "center" }}>
        {imgUrl.map((item, key) => {
          return <img src={`${root_url}/api/photo/${item}`} alt="#" key={key} style={{ marginBottom: "20px", width: "40%", marginLeft:"10%" }} />
        })}
      </div>
    </Container>
  );
};
export default SNS;
